import React, { useState, useEffect } from 'react';
import { compose } from 'utils/compose';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { get } from 'lodash';
import { CircularProgress } from '@mui/material';

import api from 'utils/api';
import { setCookie, getCookie } from 'utils/cookie';
import { toastApiError } from 'utils/apiError';
import { DAY_IN_MILLISECONDS } from 'constants/common';
import { ProgressContainer } from './styled';

export const RedirectManageDelivery = compose(
  inject('store'),
  observer,
)(() => {
  const { trackingCode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const verifyCode = searchParams.get('code');
  const reason = searchParams.get('reason');
  const action = searchParams.get('action');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);

        const { data, status } = await api.get(`delivery/${trackingCode}`);
        if (status !== 200) throw new Error('Invalid tracking code');

        if (!getCookie('axl_shipment_token')) {
          const shipmentID = get(data, 'shipment.id');
          const response = await api.post(
            `delivery/${trackingCode}/${shipmentID}/token`,
            {
              verify_code: verifyCode,
            },
            {
              params: {
                is_expired: false,
              },
            },
          );
          if (response.status !== 200) {
            toastApiError(response, 'Invalid verify code');
            throw new Error('Invalid verify code');
          }

          const token = response.data;
          const res = await api.get(`delivery/token/${token}`);
          const ttl = get(res, 'data.ttl', 0);
          setCookie('axl_shipment_token', token, ttl / DAY_IN_MILLISECONDS);
        }

        if (action === 'tracking_pod') return navigate(`/${trackingCode}?pod=true`);
        if (reason) return navigate(`/${trackingCode}/edit?reason=${reason}`);

        navigate(`/${trackingCode}/sessions`);
      } catch (error) {
        setLoading(false);
        setError(error.message);
      }
    };

    fetchData();
  }, [navigate, reason, trackingCode, verifyCode, action]);

  return (
    <ProgressContainer>
      {error && <span>{error}</span>}
      {loading && <CircularProgress />}
    </ProgressContainer>
  );
});
